import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  ar: {
    translation: arTranslations,
  },
};

i18n
  .use(LanguageDetector) // Detects user language automatically
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,

    // Default language
    fallbackLng: 'en',

    // Normalize detected locales ("en-US", "ar-KW") to the base language so
    // i18n.language is always exactly 'en' or 'ar' — the app compares it
    // strictly all over (dates, RTL, language toggle).
    supportedLngs: ['en', 'ar'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    
    // Enable debug mode in development
    debug: process.env.NODE_ENV === 'development',
    
    // Language detection options
    detection: {
      // Order of language detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      
      // Cache user language preference
      caches: ['localStorage'],
      
      // Key for localStorage
      lookupLocalStorage: 'i18nextLng',
    },
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    // Namespace configuration
    ns: ['translation'],
    defaultNS: 'translation',
    
    // React specific options
    react: {
      useSuspense: false,
    },
  });

// Function to check if language is RTL
export const isRTL = (language: string): boolean => {
  const rtlLanguages = ['ar', 'he', 'fa', 'ur'];
  return rtlLanguages.includes(language);
};

// Function to update document direction
export const updateDocumentDirection = (language: string): void => {
  const direction = isRTL(language) ? 'rtl' : 'ltr';
  document.documentElement.dir = direction;
  document.documentElement.lang = language;
  
  // Update CSS custom property for RTL-specific styling
  document.documentElement.style.setProperty('--text-direction', direction);
};

// Initialize direction on startup
i18n.on('languageChanged', (lng) => {
  updateDocumentDirection(lng);
});

// Set initial direction
updateDocumentDirection(i18n.language || 'en');

export default i18n; 